import { useAcl } from "vue-simple-acl";
import { ACLRoles } from "~/core/models/ACLRoles.enum";
import type { GenericParameters } from "~/core/models/GenericParameters.type";
import LxcError from "~/core/models/LxcError.class";
import type { CreateUserDelegationPayload } from "~/modules/relation/delegation/models/CreateUserDelegationPayload.interface";
import delegationService from "~/modules/relation/delegation/services/delegation.service";

export function useCreateUserDelegation({
  organizationCode,
  businessUnitCode,
}: GenericParameters) {
  let service =
    delegationService.createOrganizationUserDelegation.bind(delegationService);

  if (businessUnitCode !== undefined) {
    service =
      delegationService.createBusinessUnitUserDelegation.bind(
        delegationService,
      );
  }

  const { can } = useAcl();

  const isLoading = ref(false);
  const error: Ref<LxcError | undefined> = ref();

  async function createUserDelegation(
    userLogin: string,
    payload: CreateUserDelegationPayload,
  ) {
    isLoading.value = true;
    error.value = undefined;

    const response = await service({
      organizationCode,
      businessUnitCode,
      userLogin,
      payload,
    });

    if (LxcError.check(response)) {
      error.value = response;
    }
    isLoading.value = false;
  }

  function canCreateUserDelegation() {
    return can(ACLRoles.CAN_WRITE_RELATION);
  }

  return {
    isLoading,
    error,
    createUserDelegation,
    canCreateUserDelegation,
  };
}
